import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UpdateCustomMessageDistrictEntity } from '../../domain/entities/UpdateCustomMessageDistrictEntity'

export class UpdateCustomMessageDistrictModel extends UpdateCustomMessageDistrictEntity {

  constructor(dataDto: UpdateCustomMessageDistrictEntity) {
    super()
    mapEntityProperties<UpdateCustomMessageDistrictModel>(this, dataDto, {
      exclude: ['regions'],
      map: {
        districtIds: dataDto.districtIds,
      }
    })
  }
}
